import React, { useEffect, useState, useRef } from 'react'
import { trans } from '../../../../_providers/Translation'
import Api from '@/_helpers/Api'
import { Button, Skeleton } from '@mui/material'
import DualBarChart from '../../../partials/DualBarChart'
import { CHART_PALETTE } from '../../../partials/chartTheme'
import CompactFilterLayout from '@/components/partials/CompactFilterLayout'
import DateRange from '@/components/partials/DateRange'
import filterImage from '@/assets/img/icons/filter.svg'



const INITIAL_FILTERS = {
    date_from: null,
    date_to: null,
}

function Location() {
    const STATUSES = [
        { name: trans('tabs.completed'), ...CHART_PALETTE[2] },
        { name: trans('tabs.notCompleted'), color1: '#C5CAE9' },
    ]

    const [state, setState] = useState({
        loading: true,
        employees: [],
        completed: [],
        uncompleted: [],
    })
    const [filters, setFilters] = useState(INITIAL_FILTERS)

    const compactFilterLayoutRef = useRef(null)
    const fetchDebounceRef = useRef(null)

    useEffect(() => {
        clearTimeout(fetchDebounceRef.current)
        fetchDebounceRef.current = setTimeout(() => {
            loadData()
        }, 300)
        return () => clearTimeout(fetchDebounceRef.current)
    }, [filters])

    const loadData = () => {
        setState(prev => ({ ...prev, loading: true }))
        Api.get(`reservations/compared-data?date_from=${filters.date_from || ''}&date_to=${filters.date_to || ''}`)
            .then(res => {
                const employees = res.data.employees || []
                const results = res.data.results || {}
                setState(prev => ({
                    ...prev,
                    employees: employees.map(e => e.name),
                    completed: employees.map(e => results[e.id]?.completed || 0),
                    uncompleted: employees.map(e => results[e.id]?.not_completed || 0),
                }))
            })
            .finally(() => setState(prev => ({ ...prev, loading: false })))
    }

    function handleFilterChange(name, value) {
        setFilters(prev => ({ ...prev, [name]: value }))
    }

    function getAppliedFiltersCount() {
        return filters.date_from || filters.date_to ? 1 : 0
    }

    return (
        <div className="employees-reservations-chart">
            <div className='head'>
                <h3>{trans(`random.${filters.date_from || filters.date_to ? 'workSixMonths2' : 'workSixMonths'}`)}</h3>
                <div className='right'>
                    <ul>
                        {STATUSES.map(status => (
                            <li key={status.name}>
                                <span style={{
                                    background: status.color2
                                        ? `linear-gradient(to bottom, ${status.color1}, ${status.color2})`
                                        : status.color1
                                }}></span>
                                {status.name}
                            </li>
                        ))}
                    </ul>
                    <Button onClick={(e) => compactFilterLayoutRef.current.open(e)}>
                        <img src={filterImage} alt="Filter" />
                        {getAppliedFiltersCount() ?
                            <i>
                                {getAppliedFiltersCount()}
                            </i>
                            :
                            <></>
                        }
                    </Button>
                    <CompactFilterLayout
                        ref={compactFilterLayoutRef}
                        appliedFiltersCount={getAppliedFiltersCount()}
                        onClearClick={() => setFilters(INITIAL_FILTERS)}
                    >
                        <div className='row'>
                            <div className='col'>
                                <DateRange
                                    startDate={filters.date_from || ''}
                                    endDate={filters.date_to || ''}
                                    onStartDateChange={(date) => handleFilterChange('date_from', date)}
                                    onEndDateChange={(date) => handleFilterChange('date_to', date)}
                                />
                            </div>
                        </div>
                    </CompactFilterLayout>
                </div>
            </div>
            <hr />
            {state.loading
                ? <Skeleton variant="rectangular" height={360} />
                : (
                    <DualBarChart
                        labels={state.employees}
                        series={[
                            { name: STATUSES[0].name, color1: STATUSES[0].color1, color2: STATUSES[0].color2, data: state.completed },
                            { name: STATUSES[1].name, color1: STATUSES[1].color1, data: state.uncompleted },
                        ]}
                    />
                )
            }
        </div>
    )
}

export default Location
